import { cn } from "@/components/ui/cn";

type Tone = "neutral" | "accent" | "success" | "danger";
type Size = "sm" | "md";

const tones: Record<Tone, string> = {
  neutral: "bg-surface-muted text-muted border-border",
  accent: "bg-accent-soft text-accent border-transparent",
  success: "bg-success-soft text-success border-transparent",
  danger: "bg-danger-soft text-danger border-transparent",
};

const sizes: Record<Size, string> = {
  sm: "px-2 py-0.5 text-xs",
  md: "px-3 py-1 text-sm",
};

export interface BadgeProps {
  tone?: Tone;
  size?: Size;
  className?: string;
  title?: string;
  children: React.ReactNode;
}

/** Small pill-shaped label for status / category indicators. */
export function Badge({
  tone = "neutral",
  size = "sm",
  className,
  title,
  children,
}: BadgeProps) {
  return (
    <span
      title={title}
      className={cn(
        "inline-flex items-center rounded-full border font-medium",
        sizes[size],
        tones[tone],
        className
      )}
    >
      {children}
    </span>
  );
}
